import React from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import headerDesktop from './assets/bg-header.webp';
import headerMobile from './assets/bg-header-mobile.webp';
import { Helmet } from 'react-helmet';
import LocationLinks from './components/LocationInfo';
import LocationPage from './pages/location';
import locations from './data/locations.json';
import { useLocationRoute } from './data/locationRoutes';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import Home from './pages/home'
import About from './pages/about'
import AutoRepair from './pages/autorepairs'
import 'bootstrap/dist/css/bootstrap.min.css';

import TowingService from "./pages/towingservice";
import Contact from "./pages/contact";
import {ScrollToTop} from "./components/ScrollToTop";
import HeaderBar from "./components/HeaderBar";
import BGProducts from "./pages/bgproducts";
import NAPAAutoCare from "./pages/napaautocare";
import TireServices from "./pages/tireservices";
import Terms from "./pages/terms";
import StateInspection from "./pages/stateinspection";
import Footer from "./components/footer";
import PrivacyPolicy from "./pages/privacypolicy";
import './polish.css';


// Include icon sizing in the initial stylesheet, before hydration.
config.autoAddCss = false;

export const SiteContent = () => {
    const { page, canonicalPath } = useLocationRoute();
    const canonical = `https://www.goldwrenchauto.com${canonicalPath === '/' ? '' : canonicalPath}`;
    return (

        <>
            <Helmet>
                <title>{page === '/privacy-policy' ? 'Privacy Policy | GOLDWrench Automotive' : page === '/terms' ? 'Terms of Use | GOLDWrench Automotive' : 'GOLDWrench Automotive'}</title>
                <meta name="description" content={page === '/privacy-policy' ? 'Read the privacy policy for the GOLDWrench Automotive website.' : page === '/terms' ? 'Read the terms of use for the GOLDWrench Automotive website.' : 'GOLDWrench Automotive in Waynesboro and Staunton, Virginia.'} />
                <link rel="canonical" href={canonical} />
                <link rel="preload" as="image" href={headerMobile} media="(max-width: 768px)" />
                <link rel="preload" as="image" href={headerDesktop} media="(min-width: 769px)" />
            </Helmet>
            <ScrollToTop /> {/* Include the ScrollToTop component */}
            <a className="skip-link" href="#main-content">Skip to content</a>
            <HeaderBar />
            <LocationLinks />
            <main id="main-content" tabIndex="-1">
            <Routes>
                {locations.flatMap(location => [
                    ['/autorepairs', <AutoRepair />], ['/towingservice', <TowingService />],
                    ['/tires', <TireServices />], ['/stateinspection', <StateInspection />],
                    ['/about', <About />], ['/contact', <Contact />], ['/bgproducts', <BGProducts />],
                    ['/napa', <NAPAAutoCare />], ['/terms', <Terms />], ['/privacy-policy', <PrivacyPolicy />]
                ].map(([path, element]) => <Route key={`${location.id}${path}`} path={`/${location.id}${path}`} element={element} />))}
                <Route path="/" element={<Home />} />
                {locations.map(shop => <Route key={shop.id} path={`/${shop.id}`} element={<LocationPage shop={shop} />} />)}
                {locations.map(shop => <Route key={`legacy-${shop.id}`} path={`/locations/${shop.id}`} element={<Navigate to={`/${shop.id}`} replace />} />)}
                <Route path="/autorepairs" element={<AutoRepair />} />
                <Route path="/towingservice" element={<TowingService />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/bgproducts" element={<BGProducts/>} />
                <Route path = "/napa" element={<NAPAAutoCare />} />
                <Route path = "/tires" element={<TireServices />} />
                <Route path = "/terms" element={<Terms />} />
                <Route path = "/privacy-policy" element={<PrivacyPolicy />} />
                <Route path = "/stateinspection" element={<StateInspection />} />
                <Route path="*" element={<div className="location-page"><Helmet><title>Page not found | GOLDWrench Automotive</title><meta name="robots" content="noindex" /></Helmet><h1>Page not found</h1><a href="/">Return home</a></div>} />
            </Routes>
            </main>
            <Footer/>

        </>
    );
};

export default function App() { return <Router><SiteContent /></Router>; }
